export enum LOCALES {
    BOKMAAL = 'nb',
    NORDSAMISK = 'se',
    SOERSAMISK = 'sma',
    LULESAMISK = 'smj',
}
